module.exports = __webpack_public_path__ + "static/media/landing_small.76e6bcbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing_small.jpg
// module id = 27
// module chunks = 0